import { captureHandoffCode, captureAuthErrorCode } from './handoff';

/**
 * Captured cross-domain handoff code (`#handoff=<code>`), or null.
 *
 * The capture runs at IMPORT time, and this module is kept as the FIRST import
 * in main.ts on purpose: the fragment must be stripped from the URL before
 * vue-router's `createWebHistory()` (evaluated when router.ts is imported)
 * snapshots `window.location` — otherwise the router re-adds the hash to the
 * URL on its initial navigation. It also guarantees the code is gone before any
 * analytics is initialised.
 */
export const handoffCode = captureHandoffCode();

/**
 * Error code from a failed OAuth return, or null when nothing failed.
 *
 * Captured here for the same reason and at the same moment as the handoff code,
 * so the failed attempt is cleared from the address before the router and the
 * analytics observe it.
 */
export const authErrorCode: string | null = captureAuthErrorCode();
